import React from 'react';
import {Button, Image, Modal} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";

const NoSpaceModal = ({visible, onClose}) => {

    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-bg': 'transparent',}}>
            <Modal.Body className={'p-lg-5 p-lg-2'} style={{borderRadius: '24px', background: '#313644'}}>
                <div style={{display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent: 'center',}}>
                    <Image src={'/images/notice_icon.svg'}/>
                    <span style={{
                        fontSize: '24px',
                        fontWeight: 900,
                        background: 'linear-gradient(270deg, #723BFF 0%, #00E0FF 100%, #3D3D3D 100%)',
                        ' -webkit-background-clip': 'text',
                        '-webkit-text-fill-color': 'transparent',
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                    }}>未找到Coze空间</span>
                    <p className={'mt-4 mb-4'} style={{color: '#fff' ,textAlign: 'center',fontSize: '16px'}}>要迁移智能体，您需要先添加coze空间。请前往“我的 空间”页面添加Coze空间后再试。</p>
                    <Button variant="primary" style={{
                        border: 'none',
                        borderRadius: '66px',
                        fontWeight: 900,
                        fontSize: '18px',
                        width: '100%',
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        background: 'linear-gradient(270deg, #723BFF 0%, #00E0FF 100%, #3D3D3D 100%)'
                    }} onClick={() => {
                        navigate('/cozeList/CozeSpace');
                        onClose();
                    }}>前往添加Coze空间</Button>
                </div>

            </Modal.Body>
        </Modal>

    );
};

export default NoSpaceModal;